<template>
  <div id="timelines">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left to="dashboard" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn fab absolute to="/admin/timeline/add" right class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>  
    </v-container>
    <v-card class="mt-3">
      <v-data-table
        :headers="headers"
        :items="timelinesItens" 
        :pagination.sync="pagination" 
        class="pf-data-table" 
      >
        <template v-slot:items="props">
          <tr @click="openTask(props.item, props.index)">
            <td>
              <div :id="'task_' + props.item.task + '_' + props.index">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
              </div>
              {{ fillField('Task', props.item.task, 'task_' + props.item.task + '_' + props.index, props.item.account ? props.item.account.id : null, props.index) }}
            </td>
            <td v-html="props.item.text"></td>
            <td class="text-xs-center"><span :class="props.item.status" class="badgeTaskStatus dark">{{ props.item.status }}</span></td>
            <td>{{ formatDate( props.item.createdAt) }}</td>
            <td>{{ props.item.account ? props.item.account.name : 'Not found' }}</td>
            <!-- <td>{{ (Agency.human[0].id === props.item.createdBy.human.id ? Agency.human[0].name : props.item.createdBy.human.name) }}</td> -->
        </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="taskDialog" scrollable max-width="600">
      <v-card>
        <v-card-title>
          <div>
            <span class="title"><v-icon class="pr-2">subtitles</v-icon>{{ taskData.taskData ? taskData.taskData.name : '' }}</span><br>
            <span class="grey--text">Membership: {{ taskData.taskData ? taskData.taskData.membership : '' }}</span><br>
            <span v-bind:class="[ taskData.last_timeline ? taskData.last_timeline.status.replace(' ', '-') : '' ]" class="badgeTaskStatus dark">
              <span>{{ taskData.last_timeline ? taskData.last_timeline.status : ''}}</span>
            </span>
          </div>
        </v-card-title>
        <v-card-text class="task-dialog" @click="checkEdit">
          <v-layout row wrap>
            <v-flex class="text-xs-left" xs9>
              <h4>
                <v-icon class="pr-2">subject</v-icon>
                Description
                <v-btn flat small icon v-if="taskData.last_timeline && taskData.taskData.description && showEditDescription === false && session.role() !== 'parent'">
                  <v-icon class="edit-description" small>edit</v-icon>
                </v-btn>
              </h4>
              <template v-if="showEditDescription && session.role() !== 'parent'">
                <v-textarea
                  v-model="taskData.taskData.description"
                  box
                  auto-grow
                  placeholder="Add a more detailed description"
                  class="task-edit-description"
                ></v-textarea>
                <v-btn color="green" small dark class="btn-save-description">Save</v-btn>
              </template>
              <template v-else>
                <div id="task-description-text" class="edit-description task-description-text" v-bind:class="[ taskData.last_timeline && !taskData.taskData.description ? 'task-description-empty' : '' ]" @click="showEditDescription = true" v-html="taskData.last_timeline && taskData.taskData.description ? taskData.taskData.description : 'Add a more detailed description'"></div>
              </template>
              <template v-if="taskData.last_timeline && taskData.taskData.links && taskData.taskData.links.length > 0">
                <h4>
                  <v-icon class="pr-2">link</v-icon>
                  Links 
                </h4>
                <ul class="linkList">
                  <li v-for="(item, index) in taskData.taskData.links" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </template>
              <h4><v-icon class="pr-2">list</v-icon>Activities</h4>
              <p class="pt-2 pl-4">
                <vue-perfect-scrollbar class="activities-content">
                  <template v-for="(item, index) in taskData.timeline">
                      <div :key="index">
                        <p class="mb-0 mt-1"><span><b>{{ item.createdBy.human.name}}</b></span> - {{ item.text }}</p>
                        <span class="caption">{{ formatDate(item.createdAt, 'MM/DD/YYYY - hh:mm:ss')}}</span>
                      </div>
                      
                  </template>
                </vue-perfect-scrollbar>
              </p>
            </v-flex>
            <v-flex xs3 pa-1 align-end text-xs-center>
              <v-radio-group v-model="taskStatus" @change="setStatus(taskStatus)" class="pt-0 mt-0">
                <v-radio color="red" label="Open" value="Open"></v-radio>
                <v-radio color="yellow" label="In-Progress" value="In-Progress"></v-radio>
                <v-radio color="green" label="Closed" value="Closed"></v-radio>
              </v-radio-group>
              <v-menu
                v-if="session.role() !== 'parent'"
                offset-y
                v-model="linkModel"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    v-on="on"
                  >
                    <v-icon>insert_link</v-icon>Link Add
                  </v-btn>
                </template>

                <v-card width="250">
                  <v-toolbar color="primary" dark dense>
                    <div class="title">Insert a link</div>
                  </v-toolbar>

                  <v-divider></v-divider>

                  <v-list>
                    <v-list-tile>
                      <v-form v-model="linkIsvalid" lazy-validation>
                        <v-text-field
                        v-model="newLink"
                        :value="newLink"
                        label="Enter link"
                        :rules="urlRule"
                        clearable
                        :hint="'http://www.example.com/page'"
                      ></v-text-field>
                      </v-form>
                      
                    </v-list-tile>
                  </v-list>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn flat @click="CloseAddLink()">Cancel</v-btn>
                    <v-btn color="primary" :disabled="newLink === null" flat @click="addLink(newLink)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat="flat" @click.native="taskDialog = false; showEditDescription = false">Save</v-btn>
          <v-btn flat="flat" @click.native="taskDialog = false; showEditDescription = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* global session router store config */
import { getCollection, formatDate, getOne, update, create } from '../../helpers/helpers';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapGetters } from 'vuex';

export default {
  components: {
    VuePerfectScrollbar
  },
  data: () => ({
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    headers: [
      { text: 'Task', value: 'task', align: 'left' },
      { text: 'Comment', value: 'text', align: 'left' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Date', value: 'createdAt' },
      { text: 'Assigned Account', value: 'account.name' },
      // { text: 'Done By', value: 'createdBy.human.name' },
    ],
    taskDialog: false,
    timelinesItens: [],
    taskData: {
      timeline: []
    },
    taskStatus: '',
    statusTaskItems: ['Closed', 'In-Progress', 'Open'],
    linkModel: false,
    newLink: null,
    linkIsvalid: false,
    urlRule: [ 
      v => !!v || 'URL link is required',
      v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(v) || 'URL must be valid'
    ],
    showEditDescription: false,
    originalDescription: null,
    filterTasks: 'all'
  }),
  computed: {
    ...mapGetters(['Timeline', 'Account', 'Agency'])
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getTimeLines();
  },
  methods: {
    async getTimeLines () {
      let entity = `Timeline`;
      let sessionUser = session.getSession();
      let where = { createdBy: session.user().id };
      let sort = { 'updatedAt': -1 };
      let { error, data } = await getCollection(entity, true, 0, 'account', where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.timelinesItens = data.filter(timeline => timeline.text.includes('Created a new Timeline'));
          store.commit('setTimeline', this.timelinesItens);
          console.log('getTimeLines - data', data);
          console.log('getTimeLines - this.Timeline', this.Timeline);
          console.log('getTimeLines- this.timelinesItens', this.timelinesItens);
        }
      }
    },
    formatDate (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    fillField (collection, id, elementId, accountID, index) {
      window.setTimeout(() => {

        this._fillField(collection, id, elementId, accountID, index);
      }, 700);
    },
    async _fillField (collection, id, elementId, accountID, index) {
      let { data, total, error } = await getOne(collection, id);
      if (error)
      {
        console.error('error get ' + collection, error);
        document.getElementById(elementId).innerHTML = 'Task not found';
        return { data, error };
      } 
      else
      {
        // console.log('fillField', collection, id, elementId, accountID, data, this.timelinesItens[index]);
        if (data.name) {
          document.getElementById(elementId).innerHTML = data.name;
          this.timelinesItens[index].taskData = data;
          this.getTimelinesTask(id, accountID, index);
        }
        else
        {
          document.getElementById(elementId).innerHTML = 'none';
        }
        
      }
    },
    async getTimelinesTask (taskID, accountID, index) {
      let sessionUser = session.getSession();
      let entity = `Timeline`;
      let sort = { 'createdAt': -1 };
      console.log('accountID', accountID, 'taskID ' + taskID, index);
      let where = { $and: [{ account: accountID }, { 'task': taskID }] };
      let { error, data } = await getCollection(entity, true, 0, '', where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {

          this.timelinesItens[index].timeline = Object.assign({}, data);
          // this.timelinesItens[index].last_timeline = this.timelinesItens[index].timeline[0];
          this.timelinesItens[index].last_timeline = data.find(timeline => timeline.text.includes('Created a new Timeline'));
        
        } else {
          this.timelinesItens[index].timeline = [];
          this.timelinesItens[index].last_timeline = { status: 'Open', links: [] };
        }
        console.log('gettimelinesItenssTask', this.timelinesItens[index]);
      }
    },
    openTask (task, index) {
      this.taskData = Object.assign({}, task);
      this.taskData.index = index;
      this.taskStatus = this.taskData.last_timeline && this.taskData.last_timeline.status ? this.taskData.last_timeline.status : 'Open';
      this.originalDescription = this.taskData.last_timeline && this.taskData.taskData.description ? this.taskData.taskData.description : null;
      console.log('Open task', this.taskData, this.taskData.taskData.description);     
      this.taskDialog = true;
    },
    async setStatus (status) {
      if (this.taskData.last_timeline.status !== status) {
        let timelineObj = {};
        console.log(status, this.taskData.last_timeline.status);
        switch (status) {
        // eslint-disable-next-line no-case-declarations
          case 'Closed':
            this.taskData.last_timeline.status = status;
            timelineObj = {
              'text': `Closed ${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
              'status': status,
            };
            this.updateTimeline(timelineObj);
            break;
          case 'In-Progress':
            this.taskData.last_timeline.status = status;
            timelineObj = {
              'text': `Set In-Progress ${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
              'status': status,
            };
            this.updateTimeline(timelineObj);
            break;

          case 'Open':
            this.taskData.last_timeline.status = status;
            timelineObj = {
              'text': `Set Open ${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
              'status': status,
            };
            this.updateTimeline(timelineObj);
            break;
          case 'Description':
            timelineObj = {
              'text': `Edited description in ${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
              'description': this.taskData.taskData.description,
              'name': this.taskData.taskData.name,
              'status': this.taskData.last_timeline.status,
            };
            this.updateTask(timelineObj);
            this.originalDescription = this.taskData.taskData.description;
            break;
          case 'Link':
            timelineObj = {
              'text': `Inserted a link ${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
              'description': this.taskData.taskData.description,
              'name': this.taskData.taskData.name,
              'status': this.taskData.last_timeline.status,
              'links': this.taskData.taskData.links,
            };
            this.updateTask(timelineObj);
            this.originalDescription = this.taskData.taskData.description;
            this.newLink = null;
            break;
      
          default:
            timelineObj = {
              'text': `${this.taskData.taskData.name}`,
              'task': this.taskData.last_timeline.task,
            };
            this.updateTimeline(timelineObj);
            break;
        }
      }
      // console.log(timelineObj);
    },
    async updateTimeline (timelineObj) {
      timelineObj.account = this.taskData.last_timeline.account;
      
      let { error, data } = await create('Timeline', timelineObj);
      if (error) {
        console.log('error', error);
      } else {

        timelineObj.text = this.taskData.text;
        let result = await update('Timeline', timelineObj, this.taskData.last_timeline.id);
        if (result.error) {
          console.log('result.error', result.error);
        } else {
          // console.log('update(Timeline)', result.data);
        }
        this.getTimeLines();
      }
      
    },
    async updateTask (timelineObj) {
      timelineObj.account = this.taskData.last_timeline.account;
      
      let { error, data } = await create('Timeline', timelineObj);
      if (error) {
        console.log('error', error);
      } else {

        timelineObj.text = this.taskData.text;
        let result = await update('Task', timelineObj, this.taskData.last_timeline.task);
        if (result.error) {
          console.log('result.error', result.error);
        } else {
          console.log('update(Task)', result.data);
        }
        this.getTimeLines();
      }
      
    },
    checkEdit (e) {
      console.log('checkEdit', this.originalDescription !== this.taskData.taskData.description && this.taskData.taskData.description !== undefined);
      if (e.target.localName === 'pre' || e.target.className.includes('edit-description')) {
        this.showEditDescription = true;
      } else if (e.target.localName !== 'textarea') {
        this.showEditDescription = false;
        if (this.originalDescription !== this.taskData.taskData.description && this.taskData.taskData.description !== undefined) { 
          this.setStatus('Description');
        }
      }
      // this.showEditDescription = false;
      // console.log(e.target.className.includes('edit-description'), e.target.localName, this.taskData.taskData.description, this.showEditDescription);
    },
    CloseAddLink () {
      this.linkModel = false;
      this.newLink = null;
      // console.log('CloseAddLink()');
    },
    async addLink (e) {
      this.linkModel = false;
      this.taskData.taskData.links.push(e);
      this.setStatus('Link');
    },
  }
};
</script>
<style scoped>
td >>> p {
  margin-bottom: 0 !important;
}
.badgeTaskStatus {
  border-radius: 1.25rem;
  display: inline-block;
  padding: 0px 15px !important;
  font-size: 11px !important;
  color: #fff;
  height: 15px;
}
.Open {
  background-color: #F44336 !important;
}
.Closed {
  background-color: #4caf50 !important;
}
.In-Progress {
  background-color: #FFEB3B !important;
  color: #333 !important;
}
.activities-content {
  height: 326px;
}
.task-edit-description {
  font-size: 14px;
  padding-left: 35px;
}
.task-edit-description >>> textarea {
  margin: 10px 0px 0px 12px;
}
.task-dialog {
  max-height: 100% !important;
}
.task-description-text {
  padding: 16px 0px 16px 0px;
  margin-left: 35px;
}
.task-description-text pre{
  font-family: inherit !important;
}
.task-description-empty {
  padding: 16px 0px 16px 24px;
  background-color: #f3f3f3;
  border-radius: .25rem;
}
.task-description-empty:hover {
  background-color: #e8e8e8;
}
.btn-save-description {
  margin: -25px 0px 5px 34px;
}
.linkList {
    list-style: none;
    padding-left: 36px;
    padding-bottom: 20px;
}
.messages-list {
  height: 450px;
}
.messages-content {
  height: 255px;
}
.messages-conversation {
  height: 340px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Timelines/admin_list.vue